import clsx from 'clsx';
import { type FormikProps } from 'formik';

interface Step1Props {
  formik: FormikProps<{ email: string }>;
}

const Step1 = ({ formik }: Step1Props) => {
  return (
    <div className="w-100">
      <div className="text-center mb-10">
        <h1 className="text-gray-900 fw-bolder mb-3">Esqueceu a senha?</h1>
        <div className="text-gray-600 fw-semibold fs-6">Digite o seu e-mail para recuperar a senha</div>
      </div>

      <div className="fv-row mb-8">
        <label className="form-label fw-bolder text-gray-600 fs-6" htmlFor="forgot-password-email">
          Email
        </label>
        <input
          autoComplete="email"
          id="forgot-password-email"
          placeholder="Digite seu e-mail"
          type="email"
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            { 'is-valid': formik.touched.email && !formik.errors.email },
          )}
        />
        {!!formik.touched.email && !!formik.errors.email && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <span role="alert">{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Step1;
